import React, { useState } from "react";
import clsx from "clsx";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import format from "date-fns/format";
import isValid from "date-fns/isValid";
import isSameDay from "date-fns/isSameDay";
import endOfWeek from "date-fns/endOfWeek";
import startOfWeek from "date-fns/startOfWeek";
import isWithinInterval from "date-fns/isWithinInterval";
import { createStyles } from "@material-ui/styles";
import { IconButton, withStyles } from "@material-ui/core";
import DateRangeIcon from "@material-ui/icons/DateRange";
import { cx } from "emotion";

const styles = createStyles((theme) => ({
  dayWrapper: {
    position: "relative",
  },
  day: {
    width: 36,
    height: 36,
    fontSize: theme.typography.caption.fontSize,
    margin: "0 2px",
    color: "inherit",
  },
  customDayHighlight: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "2px",
    right: "2px",
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "50%",
  },
  nonCurrentMonthDay: {
    color: theme.palette.text.disabled,
  },
  highlightNonCurrentMonthDay: {
    color: "#676767",
  },
  highlight: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  firstHighlight: {
    extend: "highlight",
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%",
  },
  endHighlight: {
    extend: "highlight",
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%",
  },
  outerDiv: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #EEEEEE",
    borderRadius: 8,
    paddingTop: 5,
    width: 255,
    height: 40,
    float: "left",
  },
}));

function DatePickerFilter(props) {
  const { classes } = props;
  const [selectedDate, handleDateChange] = useState(new Date());

  const formatWeekSelectLabel = (date, invalidLabel) => {
    let dateClone = new Date(date);

    const start = startOfWeek(dateClone);
    const end = endOfWeek(dateClone);

    return dateClone && isValid(dateClone)
      ? `${format(start, "dd MMM yyyy")} - ${format(end, "dd MMM yyyy")}`
      : invalidLabel;
  };

  const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
    let dateClone = date;
    let selectedDateClone = selectedDate;

    const start = startOfWeek(selectedDateClone);
    const end = endOfWeek(selectedDateClone);

    const dayIsBetween = isWithinInterval(dateClone, { start, end });
    const isFirstDay = isSameDay(dateClone, start);
    const isLastDay = isSameDay(dateClone, end);

    const wrapperClassName = clsx({
      [classes.highlight]: dayIsBetween,
      [classes.firstHighlight]: isFirstDay,
      [classes.endHighlight]: isLastDay,
    });

    const dayClassName = clsx(classes.day, {
      [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
      [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
    });

    return (
      <div className={wrapperClassName}>
        <IconButton className={dayClassName}>
          <span>{format(dateClone, "d")}</span>
        </IconButton>
      </div>
    );
  };

  React.useEffect(() => {
    console.log(selectedDate)
  }, [selectedDate])

  return (
    <div className={cx(classes.outerDiv,"cursor-pointer")}>
      <DateRangeIcon style={{ marginTop: 3, marginLeft: 13, marginRight: 5 }} />
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          style={{ width: 210, cursor: "pointer" }}
          variant="dialog"
          emptyLabel
          InputProps={{
            disableUnderline: true,
          }}
          value={selectedDate}
          renderDay={renderWrappedWeekDay}
          onChange={handleDateChange}
          labelFunc={formatWeekSelectLabel}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
}

export default withStyles(styles)(DatePickerFilter);
